import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BaseComponent } from 'src/app/base.component';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { invokeUpdateApiKey, resultUpdateApiKey } from 'src/app/store/locationPartner/location-partner.action';
import { JwtService } from '../../services/jwt.service';
import { Observable, takeUntil } from 'rxjs';
import { SuccessDto } from '../../models/success-dto';
import { updateAPIkeySelector } from 'src/app/store/locationPartner/location-partner.selectors';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../data/constants';
import { UtilFunctions } from 'src/app/utils/utilFunctions';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: ['./api-key.component.scss']
})
export class ApiKeyComponent extends BaseComponent implements OnInit {
  @Input() hideKey: boolean = true;
  privateKey: string = Constants.privateKeyPlaceholder;
  publicKey: string;
  updateSuccessful$: Observable<SuccessDto | null>;
  email: string | null = null;
  modalRef: NgbModalRef;
  cropKey: boolean = true;
  seeKeyIcon: string = `assets/identity/keyShow.svg`
  copyHovered: boolean = false;
  copyActive: boolean = false;

  @ViewChild("modalContent", { static: true })
  modalContent!: TemplateRef<any>;

  showWarning() {
    this.modalRef = this.modalService.open(this.modalContent);
  }

  closeWarning() {
    this.modalRef.close();
  }

  copyKey() {
    if (!this.hideKey) {
      navigator.clipboard.writeText(this.privateKey);
      this.copyActive = true;
      setTimeout(() => {
        this.copyActive = false;
      }, 2000)
    }
  }

  copyHover(state: boolean) {
    this.copyHovered = state;
  }

  generateKeys() {
    window.crypto.subtle
    .generateKey(
      {
        name: "RSA-PSS",
        // Consider using a 4096-bit key for systems that require long-term security
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: "SHA-256",
      },
      true,
      ["sign", "verify"],
    )
    .then((keyPair) => {
      UtilFunctions.exportCryptoKey(keyPair.publicKey, false).then(key => {
        this.publicKey = key;
        this.store.dispatch(invokeUpdateApiKey({apiKey: key, email: this.email ?? this.jwtService.getEmail()}))
      })
      UtilFunctions.exportCryptoKey(keyPair.privateKey, true).then(key => {
        this.privateKey = key;
      })
    });
  }

  constructor(
    private store: Store<AppStateInterface>,
    private jwtService: JwtService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {  

    super(store);
    this.updateSuccessful$ = this.store
    .pipe(select(updateAPIkeySelector))
    .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.updateSuccessful$.subscribe((result: SuccessDto | null) => {
      if (result) {
        this.hideKey = false;
        this.closeWarning();
        this.toastrService.success(this.translate.instant(`response.success.${result.message}`));
        this.store.dispatch(resultUpdateApiKey({ apiKeySuccess: null }));
      }
    })
  }

  toggleCropKey(): void {
    this.cropKey = !this.cropKey;
    this.seeKeyIcon = `assets/identity/key${this.cropKey ? 'Show' : 'Hide'}.svg`;
  }
}
